import React, { CSSProperties } from 'react';
import { useDeviceType, LinkButton, UIHeading2 } from '@cian/ui-kit';

import { TPostContentRecommendedOffersState } from '../../../../types/postContentRecommendedOffers';
import { IRecommendationOfferSchema } from '../../../../repositories/journal/entities/recommendations/RecommendationOfferSchema';
import { Scrolling, ScrollingWithControls } from '../../../../components/Scrolling';
import { PostContentRecommendedOffersGroup } from '../PostContentRecommendedOffersGroup';
import * as s from './PostContentRecommendedOffersSlider.css';

interface IPostContentRecommendedOffersSlider {
  group: TPostContentRecommendedOffersState;
  offerWidth: CSSProperties['width'];
  offerHeight: CSSProperties['height'];
  scrollLength: number;
  onOfferClick(offer: IRecommendationOfferSchema, index: number): void;
}

/**
 * Слайдер рекомендованных оферов в теле поста
 */
export const PostContentRecommendedOffersSlider = ({
  group,
  offerWidth,
  offerHeight,
  scrollLength,
  onOfferClick,
}: IPostContentRecommendedOffersSlider) => {
  const deviceType = useDeviceType();
  const isDesktop = () => deviceType === 'desktop';
  const isPhone = () => deviceType === 'phone';

  const slides = isDesktop() ? (
    <ScrollingWithControls scrollLength={scrollLength} controlsSize={'M'} controlsType={'absolute'}>
      <PostContentRecommendedOffersGroup
        group={group}
        width={offerWidth}
        height={offerHeight}
        onOfferClick={onOfferClick}
      />
    </ScrollingWithControls>
  ) : (
    <Scrolling>
      <PostContentRecommendedOffersGroup
        group={group}
        width={offerWidth}
        height={offerHeight}
        onOfferClick={onOfferClick}
      />
    </Scrolling>
  );

  return (
    <div className={s['wrapper']}>
      <div className={s['title-wrapper']}>
        {group.title && <UIHeading2>{group.title}</UIHeading2>}
        {!isPhone() && group.url && (
          <LinkButton theme={'fill_secondary'} href={group.url}>
            Смотреть все
          </LinkButton>
        )}
      </div>

      {slides}

      {isPhone() && group.url && (
        <div className={s['button-wrapper']}>
          <LinkButton theme={'fill_secondary'} href={group.url} target={'_blank'}>
            Смотреть все
          </LinkButton>
        </div>
      )}
    </div>
  );
};
